export class FraudReportEntries {
    public userId: number;
    public mobileNumber: string;
    public flaggedReason: string;
    public dateCreatedUtc: string;
    public transactionStartDate: string;
    public transactionEndDate: string;
    public userStatus: string;
    public userActive: boolean;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/fraud-reports/fraud-report-entries.ts